import { render, staticRenderFns } from "./warrantyPolicy.vue?vue&type=template&id=52adbcea&scoped=true"
var script = {}
import style0 from "./warrantyPolicy.vue?vue&type=style&index=0&id=52adbcea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52adbcea",
  null
  
)

export default component.exports